import { Plane } from "lucide-react";

export const Brand = ({ compact = false }) => (
  <div className="flex items-center gap-3 min-w-0" data-testid="brand-logo">
    <div className="h-9 w-9 shrink-0 rounded-md bg-amber-500/10 border border-amber-500/40 grid place-items-center">
      <Plane className="h-4 w-4 text-amber-500 -rotate-45" />
    </div>
    {!compact && (
      <div className="min-w-0 leading-tight">
        <p className="font-heading font-bold text-slate-100 tracking-wide truncate">L4C PART 66</p>
        <p className="text-[10px] font-mono uppercase tracking-[0.2em] text-amber-500/80 truncate">
          Admin Console
        </p>
      </div>
    )}
  </div>
);
